import * as style from "./style";
import { BackButton } from "../../BackButton";

export const WorkPageButtons = () => {
  return (
    <style.WorkPageBtns>
      <BackButton arrow={"left"} />
    </style.WorkPageBtns>
  );
};
